import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteUser } from "../../api/users";

export function useDeleteUser() {
    const qc = useQueryClient();

    return useMutation({
    mutationFn: deleteUser,

    // Optimistic update
    onMutate: async (id) => {
      await qc.cancelQueries({ queryKey: ["users"] });
      const previous = qc.getQueryData(["users"]);
      qc.setQueryData(["users"], (old = []) => old.filter((u) => u.id !== id));
      return { previous };
    },
    onError: (_err, _id, ctx) => {
      if (ctx?.previous) qc.setQueryData(["users"], ctx.previous);
    },
    onSettled: () => {
      qc.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

export default useDeleteUser;